import cSummaryTable from './cSummaryTable.vue';

export default {
  install(Vue) {
    Vue.component('cSummaryTable', cSummaryTable);
  },
};
